// reducers.js
import { SELECT_CURRENT_DOCUMENT, SET_DOCUMENT_LIST, SET_IP_ADDRESS, SET_SAS_TOKEN, SET_USER_PAGE, USER_LOGIN, USER_LOGOUT } from "./../actionTypes";


const initialState = {
  ipAddress: '',
  loggedInUserData: null,
  currentDocument: {},
  usersCurrentPage: 1,
  documentList: [
    { name: "Literacy & Numeracy Assessment", progress: 100, isNew: true },
    { name: "Health questionnaire", progress: 66, isNew: true },
    { name: "New Starter Checklist", progress: 0, isNew: true },
    { name: "Compliance and Other Documents", progress: 0, isNew: true },
    { name: "Bank Details", progress: 0, isNew: true },
    { name: "Work Experience", progress: 0, isNew: true },
    { name: "Rapid Resourcing - 48hr Opt Out Form", progress: 0, isNew: true },
    {
      name: "Rapid Resourcing Limited - Terms of Engagement",
      progress: 33,
      isNew: true,
    },
    { name: "Rapid Resourcing KID for PAYE", progress: 0, isNew: true },
    {
      name: "GDPR - Job Application Processing Consent Form",
      progress: 0,
      isNew: true,
    },
    { name: "GDPR - Policy", progress: 0, isNew: true },
  ],
  sasToken: "",
  error: "",
  success: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_CURRENT_DOCUMENT:
      return {
        ...state,
        currentDocument: action.payload,
      };
    case USER_LOGIN:
      return {
        ...state,
        usersCurrentPage: 1,
        loggedInUserData: action.payload,
      };
    case USER_LOGOUT:
      return {
        ...state,
        loggedInUserData: action.payload,
      };
    case SET_USER_PAGE:
      return {
        ...state,
        usersCurrentPage: action.payload,
      };
    case SET_DOCUMENT_LIST:
      return {
        ...state,
        documentList: action.payload,
      };
    case SET_SAS_TOKEN:
      return {
        ...state,
        sasToken: action.payload,
      };
    case SET_IP_ADDRESS:
      return {
        ...state,
        ipAddress: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
